<template><div>

	<div class="tab-pane-plan-wrapper">

		<!-- блок с локальным сообщением об ошибке -->
		<transition name="fadeControl" key="transitionError">
			<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
				<button @click="localErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
				<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(localErrorMessage)"></span>
			</div>
		</transition>

		<!-- если запущен процесс или нет доступа -->
		<template v-if="!Access">
			<div class="text-center margin-top-5">
				<div v-if="serviceStatus && (serviceStatus.loader || serviceStatus.timer)" style="margin: 80px auto">
					<span v-if="serviceStatus['loader']" class="margin-right-10 font-weight-500 font-size-120" :class="'w5-status-color-' + status">{{ serviceStatus['status'] | capitalize }} <img src="../../assets/img/loading-hor16.gif" style="margin-left: 6px" /></span>
					<span v-else-if="serviceStatus['timer']" class="margin-right-10 font-weight-500 font-size-120" :class="'w5-status-color-' + status">{{ serviceStatus['status'] | capitalize }} <font-awesome-icon icon="clock" style="margin-left: 6px" /></span>
					<span v-else class="margin-right-10 font-weight-500 font-size-120" :class="'w5-status-color-' + status">{{ serviceStatus['status'] | capitalize }}</span>
				</div>
				<template v-else>
					<img src="../../assets/img/puzzle.png" class="w5-empty-table-img" />
					<br>
					<span class="w5-empty-table-hint">{{ 'main/empty_table' | ftc }}</span>
				</template>
			</div>
		</template>
		<!-- нет активного процесса и есть права -->
		<template v-else>
			<div v-if="isDisabledPlan" class="alert alert-warning font-size-85 margin-top-15 margin-bottom-10">{{ 'plan/change_note' | ftc }}</div>
			<div v-else class="margin-top-5"></div>

			<Field
				v-if="planField && Access"
				:isVisibleRow="true"
				crud="vds"
				action="view"
				v-model="planValue"
				:Field="planField"
				:groupField="groupField"
				:removeRightPadding="true"
				:templateField="templateData"
				@params="onParams" />

			<div v-if="canShowButton === true" class="btn btn-submit margin-top-15 font-weight-300" :class="{ 'disable': !isButtonEnabled || !Access || Status !== 'active' || !planWasChanged }" @click="changePlan">
				{{ 'plan/change_button' | ftc }}
			</div>
		</template>
	</div>

	<!-- диалог подтверждения -->
	<transition name="modal">
		<div v-show="showConfirmModal" @click="hideConfirmModal" class="modal-mask">
			<div class="modal-wrapper">
				<div class="modal-container" @click.stop>

					<!-- заголовок -->
					<div class="modal-header">
						<span class="font-weight-500">{{ 'plan/change_button' | ftc }}</span>
						<button type="button" class="close" @click="hideConfirmModal">&times;</button>
					</div>

					<!-- тело диалога -->
					<div class="modal-body"><p class="padding-0-5" v-withSafeTags="localeFtc(confirmModalText)"></p></div>

					<!-- подвал -->
					<div class="modal-footer">
						<span class="btn btn-submit pull-right" @click="changePlanStart">{{ 'main/continue' | ftc }}</span>
					</div>
				</div>
			</div>
		</div>
	</transition>

</div></template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'
import Field from '@/components/elements/formfield'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'tabPlan',
	//=========================================================================
	// данные переденные родителем
	//=========================================================================
	props: [
		'plan', 'value', 'access', 'status', 'serviceStatus', 'vdsId', 'parentError', 'templateData'
	],
	//=========================================================================
	// переменные
	//=========================================================================
	data() {
		return {
			// выбранный план
			planValue: null,
			// данные поля плана
			planField: null,
			// есть ли хотя бы один дизабленный тариф
			isDisabledPlan: false,
			// доступ
			Access: false,
			Status: null,
			Error: '',

			// показывать кнопку или нет
			canShowButton: true,

			// изменился ли тариф
			isPlanChanged: true,

			localErrorMessage: '',

			showConfirmModal: false,
			confirmModalText: '',

			params: null
		}
	},
	//=========================================================================
	// при создании компонента
	//=========================================================================
	created() {
		this.planValue = this.value
		this.planField = Object.assign({}, this.plan)
		this.Access = this.access
		this.Status = this.status
		this.Error = this.parentError

		this.isDisabledPlan = false
		if (this.plan && this.plan.list && Array.isArray(this.plan.list))
		{
			this.isDisabledPlan = this.plan.list.some(p => { if (p['enable'] === false && String(this.value) !== String(p['id'])) return true })
		}

		// если это тариф-конструктор
		if (this.plan && this.plan.params && typeof this.plan.params === 'object')
		{
			// эмулируем список
			// в который включим только этот текущий тариф-конструктор
			this.isDisabledPlan = false
			this.planField.type = 'list'
			this.planField.list = [
				Object.assign({
					id: this.value,
					active: true,
					enable: true,
					selected: true
				}, this.plan)
			]
		}

		// если все таки указано что плана нет - то и у нас его нет
		if (this.plan === null) this.planField = null
	},
	//=========================================================================
	// вычисляемые свойства
	//=========================================================================
	computed: {
		// текущая группа тарифов - берем из текущего тарифа
		groupField() {
			// по умолчанию - нет группы
			let _answer = null
			if (!this.planField || !this.planField['list']) return _answer

			// найдем итем в списке тарифов
			let _list = this.planField['list']
			_list.some(item => {
				if (String(item.id) === String(this.value))
				{
					_answer = {
						value: item.plan_group
					}

					return true
				}
			})

			return _answer
		},

		// доступна ли кнопка
		isButtonEnabled() {
			// по умолчанию - нет
			let _answer = false
			if (!this.planField || !this.planField['list']) return _answer

			// найдем итем в списке тарифов
			let _list = this.planField['list']
			_list.some(item => {
				if (String(item.id) === String(this.planValue))
				{
					_answer = item.enable !== false
					return true
				}
			})

			return _answer
		},

		// изменился ли план
		planWasChanged() {
			// по умолчанию - нет
			let _answer = false
			if (!this.planField || !this.planField['list']) return _answer

			// найдем итем в списке тарифов
			let _list = this.planField['list']
			_list.some(item => {
				if (String(item.id) === String(this.planValue))
				{
					// если это не конструктор - считаем что он не меняется
					if (!item.has_params)
					{
						_answer = true
					}
					// это конструктор - у нас есть для него ответ
					else
					{
						_answer = this.isPlanChanged
					}

					return true
				}
			})

			return _answer
		}
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// навешиваем обработчик на нажатие клавиш
		document.addEventListener('keydown', this.keyDownHandler)
		// есть ли изменения в конструкторе
		EventBus.$on('w5-plan-constructor-changed', this.handlePlanConstructorChanged)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler)
		EventBus.$off('w5-plan-constructor-changed', this.handlePlanConstructorChanged)
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// обработка клавиш
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			// закрытие диалога
			if (e.keyCode === 27 && this.active) this.hideConfirmModal()
		},
		//---------------------------------------------------------------------
		// изменился ли тариф-констуктор
		//---------------------------------------------------------------------
		handlePlanConstructorChanged(value) {
			if (this.plan && this.plan.has_params)
			{
				//this.canShowButton = value
				this.isPlanChanged = value
			}
		},
		//---------------------------------------------------------------------
		// вызов диалога подтверждения смены тарифного плана
		//---------------------------------------------------------------------
		changePlan() {
			// проверка доступа
			if (!this.isButtonEnabled || !this.Access || this.Status !== 'active' || this.Error || !this.planWasChanged) return
			// если план не выбран
			if (this.planValue === undefined || this.planValue === null)
			{
				this.localErrorMessage = 'plan/not_selected'
				return
			}

			// обнулим сообщения
			this.localErrorMessage = ''
			this.confirmModalText = ''

			// если это конструктор - нужно еще передать параметры тарифа
			let _params = ''
			if (this.plan && this.plan.has_params &&
				this.params && Object.keys(this.params).length)
			{
				let _paramsArr = []
				for (let p in this.params)
				{
					_paramsArr.push(`${p}=${this.params[p]}`)
				}
				if (_paramsArr.length) _params = '&' + _paramsArr.join('&')
			}

			// запросим стоимость перехода на новый тариф
			this.$http.get(this.APIServerUrl + '/service/update/' + this.vdsId + '?additional=getPlanCost&plan_id=' + this.planValue + _params).then(
				// успех
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					if (_dt && _dt['status'] === 'ok' && 'cost' in _dt && !isNaN(parseFloat(_dt['cost'])))
					{
						// проверка достаточности средства
						let _cost = parseFloat(_dt['cost'])
						let _real = _dt['balance'] && _dt['balance']['real'] && _dt['balance']['real']['value'] ? parseFloat(_dt['balance']['real']['value']) : 0
						if (isNaN(_real)) _real = 0
						let _bonus = _dt['balance'] && _dt['balance']['bonus'] && _dt['balance']['bonus']['value'] ? parseFloat(_dt['balance']['bonus']['value']) : 0
						if (isNaN(_bonus)) _bonus = 0
						let _min = 'min' in _dt ? parseFloat(_dt['min']) : 0
						if (isNaN(_min)) _min = 0

						// средства хватает - формируем сообщение для диалога
						this.confirmModalText = this.localeFtc('plan/confirm_change').replace('{cost}', '<b>' + _cost.toFixed(2) + ' ' + this.localeFtc('main/ruble') + '</b>')

						// если хотят увеличить размер диска - нужно вывести дополнительное сообщение
						if (this.plan)
						{
							let _newDiskSize = -1
							let _oldDiskSize = -1
							// если это конструктор
							if (this.plan.has_params && this.plan.params)
							{
								_oldDiskSize = this.plan.params.disk.min
								_newDiskSize = this.plan.data.disk.value
							}
							else if (this.plan.type === 'list' && this.plan.list && this.plan.list.length)
							{
								// найдем в списке старое значение и новое
								this.plan.list.forEach(p => {
									// старое значение
									if (p && p.data && p.data.disk && String(p.id) === String(this.plan.value))
									{
										_oldDiskSize = p.data.disk.value
									}
									// новое значение
									if (p && p.data && p.data.disk && String(p.id) === String(this.planValue))
									{
										_newDiskSize = p.data.disk.value
									}
								})
							}

							// если нашли оба значение и диск увеличивают
							if (_oldDiskSize > -1 && _newDiskSize > -1 &&
								_newDiskSize > _oldDiskSize)
							{
								//this.confirmModalText += ' <br><br> ' + this.localeFtc('plan/increase_disk_size').replace('vdsina.', this.AppName + '.')
								this.confirmModalText += ' <br><br> ' + this.localeFtc('plan/increase_disk_size')
								if (this.AppName === 'macloud') {
									this.confirmModalText = this.confirmModalText.replace(
										'kak-rasshirit-diskovoe-prostranstvo-posle-smeny-tarifa',
										'rasshirenie-diskovogo-prostranstva-posle-smeny-tarifa'
									)
								}
							}
						}

						// покажем диалог
						EventBus.$emit('w5-body-scroll-disable')
						this.showConfirmModal = true
						// на этом все
						return
					}
					else if (_dt && _dt['status'] === 'error' && 'title' in _dt && _dt['title'])
					{
						// сообщение об ошибке АПИ-сервера - остальных проверок не нужно (*) Алекс
						this.localErrorMessage = this.localeFtc(_dt['title'])

						// если нехватает средств на балансе - нужно вывести это сообщение (*) Антон
						// для формирования дополнительного сообщения - получим данные тарифа
						let _real = _dt['balance'] && _dt['balance']['real'] && _dt['balance']['real']['value'] ? parseFloat(_dt['balance']['real']['value']) : 0
						if (isNaN(_real)) _real = 0
						let _bonus = _dt['balance'] && _dt['balance']['bonus'] && _dt['balance']['bonus']['value'] ? parseFloat(_dt['balance']['bonus']['value']) : 0
						if (isNaN(_bonus)) _bonus = 0
						let _min = 'min' in _dt ? parseFloat(_dt['min']) : 0
						if (isNaN(_min)) _min = 0
						let _canBonus = Helper.normalizeBooleanValue(_dt['can_bonus'])

						// проверка достаточности средства - рассчитаем остаток на счету
						let _rest = _real
						// если можно платить бонусами - добавим и их
						if (_canBonus) _rest += _bonus
						// если не хватает остатка на балансе
						if (_min > _rest)
							this.localErrorMessage = this.localErrorMessage +
							' <br/>' +
							this.localeFtc('service/creating_min_money_1')
								.replace('{sum}', Helper.FormatMoney2(_min, 2))
								.replace('{val}', this.localeFtc('main/ruble'))

						// на этом все
						return
					}

					// иная ошибка - формируем сообщение об ошибке
					let msg = this.localeFtc('plan/change_cost_unknown')
					if ('title' in _dt && _dt['title']) msg = this.localeFtc(_dt['title'])
					if ('cost' in _dt && _dt['cost'] > 0) msg += '<br>' + this.localeFtc('plan/required_sum') + ' <b>' + _dt['cost'] + ' ' + this.localeFtc('main/ruble') + '</b>'
					this.localErrorMessage = msg
				},
				// провал
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// закрыть диалог
		//---------------------------------------------------------------------
		hideConfirmModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showConfirmModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// смена тарифного плана
		//---------------------------------------------------------------------
		changePlanStart() {
			// проверка доступа
			if (!this.isButtonEnabled || !this.Access || this.Status !== 'active' || this.Error || !this.planWasChanged) return
			// если план не выбран
			if (this.planValue === undefined || this.planValue === null)
			{
				this.localErrorMessage = 'plan/not_selected'
				return
			}

			// обнулим сообщения
			this.localErrorMessage = ''

			// прячем кнопку
			this.canShowButton = false

			// закроем диалог
			this.hideConfirmModal()

			// сбросим флаг изменения тарифа-конструктора
			this.$emit('dropPlanConstructorChanged')

			// все в порядке - формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.vdsId
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						_post[_dt['model']] = {
							'plan_id': this.planValue,
							'reinstall': 0
						}
						// если есть параметры тарифа-конструктора
						if (this.params && Object.keys(this.params).length)
						{
							_post[_dt['model']]['params'] = {}
							for (let p in this.params)
							{
								let pp = p.match(/^params\[(.*)\]$/i)
								if (pp && pp.length && pp[1])
								{
									_post[_dt['model']]['params'][pp[1]] = this.params[p]
								}
							}
						}
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// установим успешное сообщение
									this.$emit('successMessage', 'service/plan_change_process_start')
									// на этом все
									return
								}

								// покажем кнопку
								this.canShowButton = true
								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// покажем кнопку
								this.canShowButton = true
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// покажем кнопку
					this.canShowButton = true
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// покажем кнопку
					this.canShowButton = true
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// изменили параметры
		//---------------------------------------------------------------------
		onParams(params) {
			this.params = params
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		'plan': function(plan, old) {
			this.planField = Object.assign({}, plan)
			this.planValue = this.value

			// если раньше было установлено значение - значит это скорей всего конец процесса,
			// и нужно показать кнопку
			if (old) this.canShowButton = true

			// ищем дизабленный тариф (но не установленный)
			this.isDisabledPlan = false
			if (plan && plan.list && Array.isArray(plan.list))
			{
				this.isDisabledPlan = plan.list.some(p => { if (p['enable'] === false && String(this.value) !== String(p['id'])) return true })
			}

			// если это конструктор
			if (plan && plan.params && typeof plan.params === 'object')
			{
				// эмулируем список
				// в который включим только этот текущий тариф-конструктор
				this.isDisabledPlan = false
				this.planField.type = 'list'
				this.planField.list = [
					Object.assign({
						id: this.value,
						active: true,
						enable: true,
						selected: true
					}, this.plan)
				]
			}

			// если все таки указано что плана нет - то и у нас его нет
			if (plan === null) this.planField = null
		},
		'access': function(access) {
			this.Access = access
		},
		'status': function(status) {
			this.Status = status
		},
		'parentError': function(value) {
			this.Error = value
		}
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Field
	}
	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>



// WEBPACK FOOTER //
// plan.vue?2a2eea6c